// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalUpdate_root__YQDFb","footer":"ModalUpdate_footer__1czAs"};